/* global axios */
import ApiClient from './ApiClient';

class HospedagensAPI extends ApiClient {
  constructor() {
    super('hospedagens', { accountScoped: true });
  }

  getUnidades(date) {
    return axios.get(this.url, { params: { date } });
  }

  sync(date) {
    return axios.post(`${this.url}/sync`, { date });
  }

  getConfig() {
    return axios.get(`${this.url}/show_config`);
  }

  createConfig(data) {
    return axios.post(`${this.url}/create_config`, { hospedagem_config: data });
  }

  updateConfig(data) {
    return axios.put(`${this.url}/update_config`, { hospedagem_config: data });
  }

  deleteConfig() {
    return axios.delete(`${this.url}/destroy_config`);
  }

  getNotifications() {
    return axios.get(`${this.url}/show_notifications`);
  }

  updateNotifications(
    templates,
    notificationInboxId,
    notificationMacros,
    notificationsPaused
  ) {
    const payload = {
      templates,
      notification_inbox_id: notificationInboxId,
      notification_macros: notificationMacros,
    };
    if (notificationsPaused !== undefined) {
      payload.notifications_paused = notificationsPaused;
    }
    return axios.put(`${this.url}/update_notifications`, payload);
  }

  getGuestsList(date) {
    return axios.get(`${this.url}/guests_list`, { params: { date } });
  }

  updatePhone(guestCod, phone) {
    return axios.put(`${this.url}/update_phone`, { guest_cod: guestCod, phone });
  }

  triggerNotifications() {
    return axios.post(`${this.url}/trigger_notifications`);
  }

  getLocalBookings(params = {}) {
    return axios.get(`${this.url}/local_bookings`, { params });
  }

  getBudgetTemplate() {
    return axios.get(`${this.url}/show_budget_template`);
  }

  updateBudgetTemplate(template) {
    return axios.put(`${this.url}/update_budget_template`, {
      budget_message_template: template,
    });
  }
}

export default new HospedagensAPI();
